function _objectDestructuringEmpty(obj) {
  if (obj == null) throw new TypeError("Cannot destructure undefined");
}

module.exports = _objectDestructuringEmpty;


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime/helpers/objectDestructuringEmpty.js
// module id = horl
// module chunks = 0